// extracted by mini-css-extract-plugin
export var numpadContainer = "_fs-1";
export var phoneButton = "_fs-0";